import GenericValidationIssueDE from './GenericValidationIssueDE';
import { FIELD_VALIDATION } from './DisplayableError';

function wizardStepContainsDTOField(wizardStep, dtoName, dtoFieldName) {
    return wizardStep.contents
        .some(content => content.dtoName === dtoName
                && content.fields.includes(dtoFieldName));
}


function getWizardSteps({relatedEntity}, validationMapping) {

    const { dtoName, dtoFieldName} = relatedEntity;

    return validationMapping
        .filter(wizardStep => wizardStepContainsDTOField(wizardStep, dtoName, dtoFieldName))
        .map(wizardStep => wizardStep.name);
}

export default class FieldValidationIssueDE extends GenericValidationIssueDE {
    constructor(fieldValidationIssue, validationMapping) {
        const {
            relatedEntity,
            reason,
        } = fieldValidationIssue;

        super(fieldValidationIssue, validationMapping);

        const {
            publicID,
            displayName,
            dtoFieldName,
            dtoName,
        } = relatedEntity;


        this.id = `${publicID} - ${reason}`;
        this.title = displayName;
        this.type = FIELD_VALIDATION;
        this.wizardSteps = getWizardSteps(fieldValidationIssue, validationMapping);
        this.description = reason;
        this.dtoFieldName = dtoFieldName;
        this.dtoName = dtoName;
    }
}